module.exports = __webpack_public_path__ + "img/menu4.6fb35b4f.png";